import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { darkBlue } from 'asterX-UIkit/constants/colors'

const useStyles = makeStyles(theme => ({
	label: {
		fontWeight: 700,
		fontSize: 16,
		color: darkBlue,
		cursor: 'help'
	}
}))
const AsterTitleTypography = ({ label, align = 'center', ...props }) => {
	const classes = useStyles()
	return (
		<Typography className={classes.label} align={align} {...props}>
			{label}
		</Typography>
	)
}
export default AsterTitleTypography
